import dayjs from 'dayjs';

export const FORM_SEARCH = ({ onEnter }) => {
  return [
    {
      name: 'search',
      label: 'ค้นหารายการ (กรอกข้อมูลแล้วกด Enter เพื่อค้นหา)',
      type: 'INPUT',
      helper:
        'Tips : สามารถค้นหาด้วย รหัสส่วนลด (promotionHeadCode) , เบอร์ , รหัสลูกค้า , ชื่อลูกค้า',
      span: 16,
      placeholder: 'ค้นหาข้อมูลการใช้คูปอง',
      onEnter,
    },
    {
      name: 'startDate',
      label: 'ค้นหาข้อมูลการใช้คูปองโดยอิงวันที่',
      type: 'DATE_RANGE',
      placeholder: '',
      span: 8,
    },
  ];
};

export const searchDefaultValue = {
  search: '',
  startDate: [dayjs().startOf('month'), dayjs()],
};
